export default "__VITE_PUBLIC_ASSET__7c7e188b__"